import { useMutation } from "@tanstack/react-query";

export const useEntityFetcher = <T>(
  mutationFn: (id: string) => Promise<T>,
  setState: (data: T) => void
) => {
  return useMutation({
    mutationFn,
    onSuccess: setState,
  });
};
